import { Schema } from "@comparaonline/products-schema";

type Attribute = Schema.Maybe<Schema.ProductListProductAttribute>;
type GetAttributes = (product: Schema.ProductListProduct) => Schema.ProductListProductAttribute[];

const isActive = (attribute: Attribute) => Boolean(attribute) && attribute!.enabled;

const filterActive = (attributes: Attribute[]) =>
  attributes.filter(isActive) as Schema.ProductListProductAttribute[];

export const getAttributes: GetAttributes = ({ productAttributes }) =>
  Array.isArray(productAttributes) ? filterActive(productAttributes) : [];
